import React, { useState, useContext, useEffect } from 'react'
import { useHistory } from 'react-router-dom'

import { SubscribeToPlan } from '../../../../../store/SubscriptionClient'
import { GetSubscriptionPlans } from '../../../../../store/ContentfulClient'

import IpsaContext from '../../../../../context/IpsaContext'
import useCookie from '../../../../../hooks/useCookie'

const RegisterNewSubscription = () => {
    const { refreshUser } = useContext(IpsaContext)
    const [errorMessage, setErrorMesage] = useState('')

    const [regCookieValue, setRegCookieValue] = useCookie('signUpPlanId')
    const [affiliateCookieValue, setAffiliateCookieValue] = useCookie('affId')

    const history = useHistory()

    useEffect(() => {
        GetSubscriptionPlans(null, regCookieValue).then((plans) => {
            let planId = ''
            if (plans.length === 0) {
                setErrorMesage('No plans found. Contact an admin')
            } else if (plans.length === 1) {
                var plan = plans[0]
                const {
                    fields: { stripePlanId },
                } = plan

                planId = stripePlanId
            } else {
                var plan = plans.sort((a, b) => {
                    return a.fields.price - b.fields.price
                })[0]

                const {
                    fields: { stripePlanId },
                } = plan

                planId = stripePlanId
            }

            SubscribeToPlan(planId, 'freeNoPayment', true, '', affiliateCookieValue)
                .then(() => {
                    window.location.href = '/'
                })
                .catch((error) => {
                    refreshUser()
                    if (error && error.response && error.response.status === 422) {
                        setErrorMesage(
                            'Error subscribing to plan, probably already subscribed. Will redirect to home page in 3 seconds'
                        )
                        setTimeout(() => {
                            history.push('/')
                        }, 3000)
                    } else {
                        setErrorMesage('Error subscribing to plan. Contact an admin')
                    }
                })
        })
    }, [regCookieValue])

    if (errorMessage) {
        return <p>{errorMessage}</p>
    }

    return <p>Enrolling in free trial ...</p>
}

export default RegisterNewSubscription
